import styled from 'styled-components'

// Components
import { Body } from 'heeds-ds'

export const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 14px;
`

export const ButtonContainerRight = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
  gap: 32px;
`

export const Comment = styled(Body).attrs(() => ({
  type: 'copy3',
}))`
  overflow-wrap: break-word;
`
